const DefaultBranchInfoState = {
    details:[],
    is_list:false,
    pagination_data:[],
}

export const BranchInfoState = {data: DefaultBranchInfoState}